export default () => ({
  trainingTypes: []
})
